/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.3.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import moment from "moment";

export class ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Вход эксперта.
     * @param body Данные для входа.
     * @return Эксперт успешно авторизован.
     */
    login(body: LoginExpert): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0444\u043e\u0440\u043c\u0430\u0442 \u0434\u0430\u043d\u043d\u044b\u0445.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043b\u043e\u0433\u0438\u043d /\u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Возвращает профиль авторизованного эксперта
     * @return Успешно.
     */
    profile(): Promise<Expert> {
        let url_ = this.baseUrl + "/api/v1/account/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile(_response);
        });
    }

    protected processProfile(response: Response): Promise<Expert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Expert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Expert>(<any>null);
    }

    /**
     * Подтверждение учетной записи, проверка токена
     * @param body (optional) 
     * @return Success
     */
    checkAccountConfirmationToken(body: CheckAccountConfirmationToken | undefined): Promise<ExpertConfirmationData> {
        let url_ = this.baseUrl + "/api/v1/account/check-confirmation-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckAccountConfirmationToken(_response);
        });
    }

    protected processCheckAccountConfirmationToken(response: Response): Promise<ExpertConfirmationData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertConfirmationData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertConfirmationData>(<any>null);
    }

    /**
     * Отправка кода верификации на телефон эксперта для регистрации.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendRegistrationVerificationCode(body: SendVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-confirmation-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRegistrationVerificationCode(_response);
        });
    }

    protected processSendRegistrationVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации соискателя для регистрации.
     * @param body Данные для проверки.
     * @return Success
     */
    checkRegistrationVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-confirmation-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckRegistrationVerificationCode(_response);
        });
    }

    protected processCheckRegistrationVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Подтверждение учетной записи
     * @param body (optional) 
     * @return Success
     */
    confirmAccount(body: ConfirmAccount | undefined): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmAccount(_response);
        });
    }

    protected processConfirmAccount(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Отправка кода верификации на телефон эксперта для сброса пароля.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendResetPasswordVerificationCode(body: SendVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-reset-password-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendResetPasswordVerificationCode(_response);
        });
    }

    protected processSendResetPasswordVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации эксперта для сброса пароля.
     * @param body Данные для проверки.
     * @return Success
     */
    checkResetPasswordVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-reset-password-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckResetPasswordVerificationCode(_response);
        });
    }

    protected processCheckResetPasswordVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сброс пароля существующего эксперта.
     * @param body Данные для сброса пароля.
     * @return OK
     */
    resetPassword(body: ResetPassword): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0432\u0435\u0440\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u0438.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("\u041d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d \u0441\u043e\u0438\u0441\u043a\u0430\u0442\u0435\u043b\u044c \u0441 \u0443\u043a\u0430\u0437\u0430\u043d\u043d\u044b\u043c \u043d\u043e\u043c\u0435\u0440\u043e\u043c \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Отправка кода верификации на телефон эксперта для изменения номера.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendUpdatePhoneVerificationCode(body: SendVerificationCodeForUpdatePhone): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-update-phone-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendUpdatePhoneVerificationCode(_response);
        });
    }

    protected processSendUpdatePhoneVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации эксперта для изменения номера.
     * @param body Данные для проверки.
     * @return Success
     */
    checkUpdatePhoneVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-update-phone-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckUpdatePhoneVerificationCode(_response);
        });
    }

    protected processCheckUpdatePhoneVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сохраняет изменения в профиле соискателя
     * @param body (optional) 
     * @return Успешно.
     */
    updatePhone(body: UpdatePhone | undefined): Promise<Expert> {
        let url_ = this.baseUrl + "/api/v1/account/update-phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePhone(_response);
        });
    }

    protected processUpdatePhone(response: Response): Promise<Expert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Expert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Expert>(<any>null);
    }

    /**
     * Возвращает состояние событий
     * @return Успешно.
     */
    getEventsState(): Promise<EventsStateHolder> {
        let url_ = this.baseUrl + "/api/v1/account/events-state";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEventsState(_response);
        });
    }

    protected processGetEventsState(response: Response): Promise<EventsStateHolder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventsStateHolder.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventsStateHolder>(<any>null);
    }

    /**
     * @return Success
     */
    getCaptcha(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptcha(_response);
        });
    }

    protected processGetCaptcha(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Подтверждение электронной почты
     * @param body (optional) 
     * @return Success
     */
    confirmEmailByToken(body: ConfirmEmailByToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/confirm-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmailByToken(_response);
        });
    }

    protected processConfirmEmailByToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Повторная отправка подтверждающего письма на почту
     * @param body (optional) 
     * @return Success
     */
    sendConfirmationEmailAgain(body: SendConfirmationEmailAgain | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/send-confirmation-email-again";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendConfirmationEmailAgain(_response);
        });
    }

    protected processSendConfirmationEmailAgain(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Смена пароля
     * @return Успешно.
     */
    changePassword(body: ChangePassword): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Возвращает список свидетельств эксперта
     * @return Успешно.
     */
    getExpertCertificates(): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/certificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertCertificates(_response);
        });
    }

    protected processGetExpertCertificates(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Добавляет свидетельство эксперта
     * @param regNumber (optional) 
     * @param issueDate (optional) 
     * @param expireDate (optional) 
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @return Успешно.
     */
    addExpertCertificate(regNumber: string | undefined, issueDate: moment.Moment | undefined, expireDate: moment.Moment | undefined, contentType: string | undefined, contentDisposition: string | undefined, headers: { [key: string]: string[]; } | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/certificates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (regNumber === null || regNumber === undefined)
            throw new Error("The parameter 'regNumber' cannot be null.");
        else
            content_.append("regNumber", regNumber.toString());
        if (issueDate === null || issueDate === undefined)
            throw new Error("The parameter 'issueDate' cannot be null.");
        else
            content_.append("issueDate", issueDate.toJSON());
        if (expireDate === null || expireDate === undefined)
            throw new Error("The parameter 'expireDate' cannot be null.");
        else
            content_.append("expireDate", expireDate.toJSON());
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("contentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("contentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("fileName", fileName.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddExpertCertificate(_response);
        });
    }

    protected processAddExpertCertificate(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Возвращает свидетельство эксперта
     * @return Успешно.
     */
    getExpertCertificate(certificateId: string): Promise<ExpertCertificate> {
        let url_ = this.baseUrl + "/api/v1/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertCertificate(_response);
        });
    }

    protected processGetExpertCertificate(response: Response): Promise<ExpertCertificate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertCertificate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate>(<any>null);
    }

    /**
     * Обновляет свидетельство эксперта
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @param regNumber (optional) 
     * @param issueDate (optional) 
     * @param expireDate (optional) 
     * @return Успешно.
     */
    updateExpertCertificate(certificateId: string, contentType: string | undefined, contentDisposition: string | undefined, headers: { [key: string]: string[]; } | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, regNumber: string | undefined, issueDate: moment.Moment | undefined, expireDate: moment.Moment | undefined): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("contentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("contentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("fileName", fileName.toString());
        if (regNumber === null || regNumber === undefined)
            throw new Error("The parameter 'regNumber' cannot be null.");
        else
            content_.append("regNumber", regNumber.toString());
        if (issueDate === null || issueDate === undefined)
            throw new Error("The parameter 'issueDate' cannot be null.");
        else
            content_.append("issueDate", issueDate.toJSON());
        if (expireDate === null || expireDate === undefined)
            throw new Error("The parameter 'expireDate' cannot be null.");
        else
            content_.append("expireDate", expireDate.toJSON());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExpertCertificate(_response);
        });
    }

    protected processUpdateExpertCertificate(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Удаляет свидетельство эксперта
     * @return Успешно.
     */
    removeExpertCertificate(certificateId: string): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveExpertCertificate(_response);
        });
    }

    protected processRemoveExpertCertificate(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Возвращает список заявок на экзамены.
     * @param examId (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Пользователь успешно авторизован.
     */
    getExamApplications(examId: string | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications?";
        if (examId !== undefined && examId !== null)
            url_ += "examId=" + encodeURIComponent("" + examId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplications(_response);
        });
    }

    protected processGetExamApplications(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * Возвращает список заявок на экзамены для финализации результата.
     * @param examId (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Пользователь успешно авторизован.
     */
    getExamApplicationsForFinalize(examId: string | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/finalizing?";
        if (examId !== undefined && examId !== null)
            url_ += "examId=" + encodeURIComponent("" + examId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplicationsForFinalize(_response);
        });
    }

    protected processGetExamApplicationsForFinalize(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * Возвращает заявку соискателя
     * @return Успешно.
     */
    getExamApplication(examApplicationId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplication(_response);
        });
    }

    protected processGetExamApplication(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * Допустить соискателя к экзамену
     * @return Success
     */
    admitToExam(examApplicationId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/admit-to-exam";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmitToExam(_response);
        });
    }

    protected processAdmitToExam(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Завершить защиту практики для онлайн экзамена
     * @return Success
     */
    finishPracticeDefense(examApplicationId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/finish-practice-defense";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinishPracticeDefense(_response);
        });
    }

    protected processFinishPracticeDefense(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Возвращает экзаменационную сессию пользователя.
     * @return OK
     */
    getExamSessionDetails(examApplicationId: string): Promise<ExamSessionDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/exam-session";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamSessionDetails(_response);
        });
    }

    protected processGetExamSessionDetails(response: Response): Promise<ExamSessionDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamSessionDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamSessionDetails>(<any>null);
    }

    /**
     * Генерирует набросок рекомендаций соискателю для несданного экзамена.
     * @return OK
     */
    formatRecommendationsSketch(examApplicationId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/recommendations-sketch";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFormatRecommendationsSketch(_response);
        });
    }

    protected processFormatRecommendationsSketch(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Установка временного пароля соискателю
     * @return Успешно.
     */
    setApplicantTempPassword(examApplicationId: string, body: SetApplicantTempPassword): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/set-temp-password";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetApplicantTempPassword(_response);
        });
    }

    protected processSetApplicantTempPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Возвращает список ЭЦ
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExaminationCenters(searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExaminationCentersList> {
        let url_ = this.baseUrl + "/api/v1/examination-centers?";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExaminationCenters(_response);
        });
    }

    protected processGetExaminationCenters(response: Response): Promise<ExaminationCentersList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExaminationCentersList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExaminationCentersList>(<any>null);
    }

    /**
     * Отправить код для подписи согласия на участие в экзамене
     * @return Success
     */
    sendCodeForAcceptExamInvite(examId: string, body: SendVerificationCodeForAcceptExamInvite): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/exam-invites/{examId}/send-code-for-accept";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeForAcceptExamInvite(_response);
        });
    }

    protected processSendCodeForAcceptExamInvite(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Согласие эксперта на участие в экзамене
     * @param examId ид экзамена
     * @return Success
     */
    acceptExamInvite(examId: string, body: AcceptExamInvite): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-invites/{examId}/accept";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcceptExamInvite(_response);
        });
    }

    protected processAcceptExamInvite(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Согласие эксперта на участие в экзамене
     * @param examId ид экзамена
     * @return Success
     */
    rejectExamInvite(examId: string): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-invites/{examId}/reject";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRejectExamInvite(_response);
        });
    }

    protected processRejectExamInvite(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Получение расписания экзаменов по фильтру, сортировка и пагинация
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExams(page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamList> {
        let url_ = this.baseUrl + "/api/v1/exams?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExams(_response);
        });
    }

    protected processGetExams(response: Response): Promise<ExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamList>(<any>null);
    }

    /**
     * Получение списка экзаменов в процессе обработки
     * @return Success
     */
    getExamsInProcessing(): Promise<Exam[]> {
        let url_ = this.baseUrl + "/api/v1/exams/in-processing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamsInProcessing(_response);
        });
    }

    protected processGetExamsInProcessing(response: Response): Promise<Exam[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Exam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Exam[]>(<any>null);
    }

    /**
     * Получение списка экзаменов для подписания протоколов совета
     * @return Success
     */
    getExamsForSigningSovietProtocols(): Promise<Exam[]> {
        let url_ = this.baseUrl + "/api/v1/exams/for-signing-soviet-protocols";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamsForSigningSovietProtocols(_response);
        });
    }

    protected processGetExamsForSigningSovietProtocols(response: Response): Promise<Exam[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Exam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Exam[]>(<any>null);
    }

    /**
     * Получение списка приглашений для участия в экзаменах
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamInvites(page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamList> {
        let url_ = this.baseUrl + "/api/v1/exams/invites?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamInvites(_response);
        });
    }

    protected processGetExamInvites(response: Response): Promise<ExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamList>(<any>null);
    }

    /**
     * Фильтр всех экзаменов эксперта
     * @param qualificationIds (optional) 
     * @param examinationCenterIds (optional) 
     * @param filteredExamStatus (optional) 
     * @param from (optional) Дата экзамена, с
     * @param to (optional) Дата экзамена, по
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamFilteredList(qualificationIds: string[] | null | undefined, examinationCenterIds: string[] | null | undefined, filteredExamStatus: FilteredExamStatus | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamList> {
        let url_ = this.baseUrl + "/api/v1/exams/filter?";
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (examinationCenterIds !== undefined && examinationCenterIds !== null)
            examinationCenterIds && examinationCenterIds.forEach(item => { url_ += "examinationCenterIds=" + encodeURIComponent("" + item) + "&"; });
        if (filteredExamStatus === null)
            throw new Error("The parameter 'filteredExamStatus' cannot be null.");
        else if (filteredExamStatus !== undefined)
            url_ += "filteredExamStatus=" + encodeURIComponent("" + filteredExamStatus) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamFilteredList(_response);
        });
    }

    protected processGetExamFilteredList(response: Response): Promise<ExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamList>(<any>null);
    }

    /**
     * Получение списка идентификаторов экзаменов нуждающихся во внимании эксперта
     * @return Success
     */
    getNeedingAttentionExamIds(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/exams/needing-attention";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNeedingAttentionExamIds(_response);
        });
    }

    protected processGetNeedingAttentionExamIds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Получение информации по экзамену
     * @param examId id экзамена
     * @return Success
     */
    getExam(examId: string): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExam(_response);
        });
    }

    protected processGetExam(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Запуск экзамена
     * @param examId id экзамена
     * @return Success
     */
    startExam(examId: string): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/start-exam";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartExam(_response);
        });
    }

    protected processStartExam(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Написать рекомендации для не сдавшего экзамен
     * @param examId id экзамена
     * @return Success
     */
    writeRecommendations(examId: string, body: WriteRecommendations): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/write-recommendations";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWriteRecommendations(_response);
        });
    }

    protected processWriteRecommendations(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Ручная оценка эссе
     * @param examId id экзамена
     * @return Success
     */
    rate(examId: string, body: Rate): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/rate";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRate(_response);
        });
    }

    protected processRate(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Отправить код для подписи протокола НОК
     * @return Success
     */
    sendCodeForSignNokProtocol(examId: string, body: SendSignatureVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/send-code-for-sign-nok-protocol";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeForSignNokProtocol(_response);
        });
    }

    protected processSendCodeForSignNokProtocol(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Подписать протокол НОК
     * @return Success
     */
    signNokProtocol(examId: string, body: SignExamProtocol): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/sign-nok-protocol";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignNokProtocol(_response);
        });
    }

    protected processSignNokProtocol(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Отправить код для подписи протокола АК
     * @return Success
     */
    sendCodeForSignAkProtocol(examId: string, body: SendSignatureVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/send-code-for-sign-ak-protocol";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeForSignAkProtocol(_response);
        });
    }

    protected processSendCodeForSignAkProtocol(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Подписать протокол АК
     * @return Success
     */
    signAkProtocol(examId: string, body: SignExamProtocol): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/sign-ak-protocol";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignAkProtocol(_response);
        });
    }

    protected processSignAkProtocol(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Отправить код для подписи протокола совета
     * @return Success
     */
    sendCodeForSignSovietProtocol(examId: string, body: SendSignatureVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/send-code-for-sign-soviet-protocol";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeForSignSovietProtocol(_response);
        });
    }

    protected processSendCodeForSignSovietProtocol(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Подписать протокол совета
     * @return Success
     */
    signSovietProtocol(examId: string, body: SignExamProtocol): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/sign-soviet-protocol";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignSovietProtocol(_response);
        });
    }

    protected processSignSovietProtocol(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Отправить код для подписи текущих протоколов совета
     * @return Success
     */
    sendCodeForSignCurrentSovietProtocols(body: SendCodeForSignCurrentSovietProtocols): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/exams/send-code-for-sign-current-soviet-protocols";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeForSignCurrentSovietProtocols(_response);
        });
    }

    protected processSendCodeForSignCurrentSovietProtocols(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Подписать текущие протоколы совета
     * @return Success
     */
    signCurrentSovietProtocols(body: SignCurrentSovietProtocols): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/exams/sign-current-soviet-protocols";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignCurrentSovietProtocols(_response);
        });
    }

    protected processSignCurrentSovietProtocols(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Возвращает список связанных ЦОК эксперта
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Успешно.
     */
    getQecs(searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExpertEcs> {
        let url_ = this.baseUrl + "/api/v1/qecs?";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQecs(_response);
        });
    }

    protected processGetQecs(response: Response): Promise<ExpertEcs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertEcs.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertEcs>(<any>null);
    }

    /**
     * Возвращает список квалификаций эксперта
     * @return Успешно.
     */
    getExpertQualifications(): Promise<ApplicantQualification[]> {
        let url_ = this.baseUrl + "/api/v1/qualifications/expert";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertQualifications(_response);
        });
    }

    protected processGetExpertQualifications(response: Response): Promise<ApplicantQualification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicantQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualification[]>(<any>null);
    }

    /**
     * Возвращает детали квалификаций эксперта.
     * @return OK
     */
    getQualificationDetails(examApplicationId: string): Promise<ApplicantQualificationDetails> {
        let url_ = this.baseUrl + "/api/v1/qualifications/expert/{examApplicationId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualificationDetails(_response);
        });
    }

    protected processGetQualificationDetails(response: Response): Promise<ApplicantQualificationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantQualificationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualificationDetails>(<any>null);
    }

    /**
     * Возвращает список квалификаций
     * @param occupationalStandardId (optional) 
     * @param readyToUse (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getQualifications(occupationalStandardId: string | null | undefined, readyToUse: boolean | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<QualificationInfoList> {
        let url_ = this.baseUrl + "/api/v1/qualifications?";
        if (occupationalStandardId !== undefined && occupationalStandardId !== null)
            url_ += "occupationalStandardId=" + encodeURIComponent("" + occupationalStandardId) + "&";
        if (readyToUse !== undefined && readyToUse !== null)
            url_ += "readyToUse=" + encodeURIComponent("" + readyToUse) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualifications(_response);
        });
    }

    protected processGetQualifications(response: Response): Promise<QualificationInfoList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationInfoList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationInfoList>(<any>null);
    }
}

export class AcceptExamInvite implements IAcceptExamInvite {
    captcha?: string | undefined;
    code!: string;

    constructor(data?: IAcceptExamInvite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AcceptExamInvite {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptExamInvite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["code"] = this.code;
        return data; 
    }
}

export interface IAcceptExamInvite {
    captcha?: string | undefined;
    code: string;
}

export class AnswerPair implements IAnswerPair {
    /** Номер вопроса */
    number!: number;
    /** Номер соответствующего вопроса,
заполняется только в случае типов: Matching, Ordering */
    matchingNumber?: number;

    constructor(data?: IAnswerPair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.matchingNumber = _data["matchingNumber"];
        }
    }

    static fromJS(data: any): AnswerPair {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerPair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["matchingNumber"] = this.matchingNumber;
        return data; 
    }
}

export interface IAnswerPair {
    /** Номер вопроса */
    number: number;
    /** Номер соответствующего вопроса,
заполняется только в случае типов: Matching, Ordering */
    matchingNumber?: number;
}

export class ApiError implements IApiError {
    code!: number;
    type!: AppExceptionType;
    message!: string;
    failures?: { [key: string]: string[]; } | undefined;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.message = _data["message"];
            if (_data["failures"]) {
                this.failures = {} as any;
                for (let key in _data["failures"]) {
                    if (_data["failures"].hasOwnProperty(key))
                        (<any>this.failures)![key] = _data["failures"][key] !== undefined ? _data["failures"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["message"] = this.message;
        if (this.failures) {
            data["failures"] = {};
            for (let key in this.failures) {
                if (this.failures.hasOwnProperty(key))
                    (<any>data["failures"])[key] = this.failures[key];
            }
        }
        return data; 
    }
}

export interface IApiError {
    code: number;
    type: AppExceptionType;
    message: string;
    failures?: { [key: string]: string[]; } | undefined;
}

export enum AppExceptionType {
    Unspecified = "unspecified",
    Validation = "validation",
    NotFound = "notFound",
    AlreadyExists = "alreadyExists",
    WrongVerificationCode = "wrongVerificationCode",
    TooManyRequests = "tooManyRequests",
    WrongCredentials = "wrongCredentials",
    AuthUserNotFound = "authUserNotFound",
    Forbidden = "forbidden",
    Captcha = "captcha",
    WrongIp = "wrongIp",
}

export class Applicant implements IApplicant {
    id!: string;
    /** Имя */
    firstName!: string;
    /** Фамилия */
    lastName!: string;
    /** Отчество */
    middleName?: string | undefined;
    sex!: Sex;
    birthDate!: moment.Moment;
    email!: string;
    emailConfirmed!: boolean;
    phone!: string;
    isExpert!: boolean;

    constructor(data?: IApplicant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.sex = _data["sex"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phone = _data["phone"];
            this.isExpert = _data["isExpert"];
        }
    }

    static fromJS(data: any): Applicant {
        data = typeof data === 'object' ? data : {};
        let result = new Applicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phone"] = this.phone;
        data["isExpert"] = this.isExpert;
        return data; 
    }
}

export interface IApplicant {
    id: string;
    /** Имя */
    firstName: string;
    /** Фамилия */
    lastName: string;
    /** Отчество */
    middleName?: string | undefined;
    sex: Sex;
    birthDate: moment.Moment;
    email: string;
    emailConfirmed: boolean;
    phone: string;
    isExpert: boolean;
}

export class ApplicantIdentityDoc implements IApplicantIdentityDoc {
    identityDocType!: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;

    constructor(data?: IApplicantIdentityDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityDocType = _data["identityDocType"];
            this.passport = _data["passport"] ? ApplicantPassport.fromJS(_data["passport"]) : <any>undefined;
            this.otherIdentity = _data["otherIdentity"] ? ApplicantOtherIdentity.fromJS(_data["otherIdentity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantIdentityDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantIdentityDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityDocType"] = this.identityDocType;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["otherIdentity"] = this.otherIdentity ? this.otherIdentity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IApplicantIdentityDoc {
    identityDocType: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;
}

/** Другой документ */
export class ApplicantOtherIdentity implements IApplicantOtherIdentity {
    /** название документа */
    title!: string;
    /** данные документа */
    data!: string;

    constructor(data?: IApplicantOtherIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ApplicantOtherIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantOtherIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["data"] = this.data;
        return data; 
    }
}

/** Другой документ */
export interface IApplicantOtherIdentity {
    /** название документа */
    title: string;
    /** данные документа */
    data: string;
}

/** паспорт */
export class ApplicantPassport implements IApplicantPassport {
    /** серия/номер */
    serialNumber!: string;
    /** кем выдан */
    issuedBy!: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue!: moment.Moment;
    /** адрес регистрации */
    registrationAddress!: string;

    constructor(data?: IApplicantPassport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.issuedBy = _data["issuedBy"];
            this.dateOfIssue = _data["dateOfIssue"] ? moment(_data["dateOfIssue"].toString()) : <any>undefined;
            this.registrationAddress = _data["registrationAddress"];
        }
    }

    static fromJS(data: any): ApplicantPassport {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantPassport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["issuedBy"] = this.issuedBy;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toISOString() : <any>undefined;
        data["registrationAddress"] = this.registrationAddress;
        return data; 
    }
}

/** паспорт */
export interface IApplicantPassport {
    /** серия/номер */
    serialNumber: string;
    /** кем выдан */
    issuedBy: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue: moment.Moment;
    /** адрес регистрации */
    registrationAddress: string;
}

export class ApplicantQualification implements IApplicantQualification {
    applicantId!: string;
    examId!: string;
    examApplicationId!: string;
    title!: string;
    level!: string;
    /** Регистрационный номер квалификации */
    regNumber!: string;
    /** Дата присвоения */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber!: string;

    constructor(data?: IApplicantQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.certRegNumber = _data["certRegNumber"];
        }
    }

    static fromJS(data: any): ApplicantQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["certRegNumber"] = this.certRegNumber;
        return data; 
    }
}

export interface IApplicantQualification {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    level: string;
    /** Регистрационный номер квалификации */
    regNumber: string;
    /** Дата присвоения */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber: string;
}

export class ApplicantQualificationDetails implements IApplicantQualificationDetails {
    applicantId!: string;
    examId!: string;
    examApplicationId!: string;
    title!: string;
    level!: string;
    /** Регистрационный номер квалификации */
    regNumber!: string;
    /** Дата присвоения */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber!: string;
    examDate!: moment.Moment;
    occupationalStandardTitle!: string;
    qecFullName!: string;
    /** Секретный код НАРК */
    secretCode!: string;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl!: string;
    /** Ссылка на документ в НАРК */
    narkDocUrl!: string;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;

    constructor(data?: IApplicantQualificationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.certRegNumber = _data["certRegNumber"];
            this.examDate = _data["examDate"] ? moment(_data["examDate"].toString()) : <any>undefined;
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qecFullName = _data["qecFullName"];
            this.secretCode = _data["secretCode"];
            this.narkPageUrl = _data["narkPageUrl"];
            this.narkDocUrl = _data["narkDocUrl"];
            this.certificateUrl = _data["certificateUrl"];
        }
    }

    static fromJS(data: any): ApplicantQualificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantQualificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["certRegNumber"] = this.certRegNumber;
        data["examDate"] = this.examDate ? this.examDate.toISOString() : <any>undefined;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qecFullName"] = this.qecFullName;
        data["secretCode"] = this.secretCode;
        data["narkPageUrl"] = this.narkPageUrl;
        data["narkDocUrl"] = this.narkDocUrl;
        data["certificateUrl"] = this.certificateUrl;
        return data; 
    }
}

export interface IApplicantQualificationDetails {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    level: string;
    /** Регистрационный номер квалификации */
    regNumber: string;
    /** Дата присвоения */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber: string;
    examDate: moment.Moment;
    occupationalStandardTitle: string;
    qecFullName: string;
    /** Секретный код НАРК */
    secretCode: string;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl: string;
    /** Ссылка на документ в НАРК */
    narkDocUrl: string;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
}

export class AuthResult implements IAuthResult {
    profile!: Expert;
    token!: string;

    constructor(data?: IAuthResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.profile = new Expert();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? Expert.fromJS(_data["profile"]) : new Expert();
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["token"] = this.token;
        return data; 
    }
}

export interface IAuthResult {
    profile: Expert;
    token: string;
}

export class ChangePassword implements IChangePassword {
    captcha?: string | undefined;
    /** Старый пароль */
    oldPassword!: string;
    /** Новый пароль */
    newPassword!: string;

    constructor(data?: IChangePassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePassword {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePassword {
    captcha?: string | undefined;
    /** Старый пароль */
    oldPassword: string;
    /** Новый пароль */
    newPassword: string;
}

export class CheckAccountConfirmationToken implements ICheckAccountConfirmationToken {
    captcha?: string | undefined;
    token!: string;

    constructor(data?: ICheckAccountConfirmationToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): CheckAccountConfirmationToken {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAccountConfirmationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        return data; 
    }
}

export interface ICheckAccountConfirmationToken {
    captcha?: string | undefined;
    token: string;
}

export class CheckedCell implements ICheckedCell {
    standard!: string;
    solution?: string | undefined;
    correct!: boolean;

    constructor(data?: ICheckedCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standard = _data["standard"];
            this.solution = _data["solution"];
            this.correct = _data["correct"];
        }
    }

    static fromJS(data: any): CheckedCell {
        data = typeof data === 'object' ? data : {};
        let result = new CheckedCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standard"] = this.standard;
        data["solution"] = this.solution;
        data["correct"] = this.correct;
        return data; 
    }
}

export interface ICheckedCell {
    standard: string;
    solution?: string | undefined;
    correct: boolean;
}

export class CheckedTable implements ICheckedTable {
    caption?: string | undefined;
    columns!: Column[];
    readonly rows?: CheckedCell[][] | undefined;
    showCorrectAndApplicantAnswer!: boolean;
    applicantAnswerRows?: string[][] | undefined;
    correctAnswerRows?: string[][] | undefined;

    constructor(data?: ICheckedTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.columns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caption = _data["caption"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Column.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                (<any>this).rows = [] as any;
                for (let item of _data["rows"])
                    (<any>this).rows!.push(item);
            }
            this.showCorrectAndApplicantAnswer = _data["showCorrectAndApplicantAnswer"];
            if (Array.isArray(_data["applicantAnswerRows"])) {
                this.applicantAnswerRows = [] as any;
                for (let item of _data["applicantAnswerRows"])
                    this.applicantAnswerRows!.push(item);
            }
            if (Array.isArray(_data["correctAnswerRows"])) {
                this.correctAnswerRows = [] as any;
                for (let item of _data["correctAnswerRows"])
                    this.correctAnswerRows!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckedTable {
        data = typeof data === 'object' ? data : {};
        let result = new CheckedTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["showCorrectAndApplicantAnswer"] = this.showCorrectAndApplicantAnswer;
        if (Array.isArray(this.applicantAnswerRows)) {
            data["applicantAnswerRows"] = [];
            for (let item of this.applicantAnswerRows)
                data["applicantAnswerRows"].push(item);
        }
        if (Array.isArray(this.correctAnswerRows)) {
            data["correctAnswerRows"] = [];
            for (let item of this.correctAnswerRows)
                data["correctAnswerRows"].push(item);
        }
        return data; 
    }
}

export interface ICheckedTable {
    caption?: string | undefined;
    columns: Column[];
    rows?: CheckedCell[][] | undefined;
    showCorrectAndApplicantAnswer: boolean;
    applicantAnswerRows?: string[][] | undefined;
    correctAnswerRows?: string[][] | undefined;
}

export class CheckVerificationCode implements ICheckVerificationCode {
    captcha?: string | undefined;
    phone!: string;
    verificationCode!: string;

    constructor(data?: ICheckVerificationCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): CheckVerificationCode {
        data = typeof data === 'object' ? data : {};
        let result = new CheckVerificationCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface ICheckVerificationCode {
    captcha?: string | undefined;
    phone: string;
    verificationCode: string;
}

export class Column implements IColumn {
    header!: string;
    width!: number;
    readonly!: boolean;
    numeric!: boolean;
    key!: boolean;
    multiline!: boolean;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.width = _data["width"];
            this.readonly = _data["readonly"];
            this.numeric = _data["numeric"];
            this.key = _data["key"];
            this.multiline = _data["multiline"];
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["width"] = this.width;
        data["readonly"] = this.readonly;
        data["numeric"] = this.numeric;
        data["key"] = this.key;
        data["multiline"] = this.multiline;
        return data; 
    }
}

export interface IColumn {
    header: string;
    width: number;
    readonly: boolean;
    numeric: boolean;
    key: boolean;
    multiline: boolean;
}

export class ConfirmAccount implements IConfirmAccount {
    captcha?: string | undefined;
    token!: string;
    password!: string;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate!: moment.Moment;
    sex!: Sex;
    verificationCode!: string;

    constructor(data?: IConfirmAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): ConfirmAccount {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        data["password"] = this.password;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface IConfirmAccount {
    captcha?: string | undefined;
    token: string;
    password: string;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate: moment.Moment;
    sex: Sex;
    verificationCode: string;
}

export class ConfirmEmailByToken implements IConfirmEmailByToken {
    captcha?: string | undefined;
    token!: string;

    constructor(data?: IConfirmEmailByToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ConfirmEmailByToken {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailByToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        return data; 
    }
}

export interface IConfirmEmailByToken {
    captcha?: string | undefined;
    token: string;
}

export enum DocumentType {
    Other = "other",
    IdentityDoc = "identityDoc",
    SecondaryEducationConfirmation = "secondaryEducationConfirmation",
    HigherEducationConfirmation = "higherEducationConfirmation",
    WorkExperienceConfirmation = "workExperienceConfirmation",
    ContinuingEducationConfirmation = "continuingEducationConfirmation",
    CertificateForExchange = "certificateForExchange",
    NoCriminalRecord = "noCriminalRecord",
    QualificationCertificate = "qualificationCertificate",
    ConsentToProcessingPersonalData = "consentToProcessingPersonalData",
}

export class EssayAnswer implements IEssayAnswer {
    factual?: string | undefined;

    constructor(data?: IEssayAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factual = _data["factual"];
        }
    }

    static fromJS(data: any): EssayAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new EssayAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factual"] = this.factual;
        return data; 
    }
}

export interface IEssayAnswer {
    factual?: string | undefined;
}

export class EventsStateHolder implements IEventsStateHolder {
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IEventsStateHolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): EventsStateHolder {
        data = typeof data === 'object' ? data : {};
        let result = new EventsStateHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IEventsStateHolder {
    eventsState?: { [key: string]: number; } | undefined;
}

export class Exam implements IExam {
    id!: string;
    date!: moment.Moment;
    qualificationId!: string;
    examinationCenterId!: string;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    qualificationEvaluationCenterName!: string;
    examinationCenterName!: string;
    address!: string;
    city!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration!: number;
    price!: number;
    /** Переаттестация */
    recertification!: boolean;
    type!: ExamType;
    qualificationEvaluationCenterId!: string;
    numberOfApplicants!: number;
    protocolNumber?: number | undefined;

    constructor(data?: IExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.examinationCenterId = _data["examinationCenterId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.recertification = _data["recertification"];
            this.type = _data["type"];
            this.qualificationEvaluationCenterId = _data["qualificationEvaluationCenterId"];
            this.numberOfApplicants = _data["numberOfApplicants"];
            this.protocolNumber = _data["protocolNumber"];
        }
    }

    static fromJS(data: any): Exam {
        data = typeof data === 'object' ? data : {};
        let result = new Exam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["examinationCenterId"] = this.examinationCenterId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["recertification"] = this.recertification;
        data["type"] = this.type;
        data["qualificationEvaluationCenterId"] = this.qualificationEvaluationCenterId;
        data["numberOfApplicants"] = this.numberOfApplicants;
        data["protocolNumber"] = this.protocolNumber;
        return data; 
    }
}

export interface IExam {
    id: string;
    date: moment.Moment;
    qualificationId: string;
    examinationCenterId: string;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    qualificationEvaluationCenterName: string;
    examinationCenterName: string;
    address: string;
    city: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration: number;
    price: number;
    /** Переаттестация */
    recertification: boolean;
    type: ExamType;
    qualificationEvaluationCenterId: string;
    numberOfApplicants: number;
    protocolNumber?: number | undefined;
}

export class ExamApplication implements IExamApplication {
    status!: ExamApplicationStatus;
    finalized!: boolean;
    statusChangeTime!: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId!: string;
    applicationSubmitDate!: moment.Moment;
    /** Обработан в НАРК */
    processedByNark!: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    applicantId!: string;
    applicantFullName!: string;
    applicantPhone!: string;
    applicantEmail!: string;
    isExpert!: boolean;
    birthDate!: moment.Moment;
    correctTheoreticalAnswersPercentage?: number | undefined;

    constructor(data?: IExamApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.finalized = _data["finalized"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.examSessionStatus = _data["examSessionStatus"];
            this.recommendations = _data["recommendations"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.processedByNark = _data["processedByNark"];
            this.examSessionReadyStatus = _data["examSessionReadyStatus"];
            this.applicantId = _data["applicantId"];
            this.applicantFullName = _data["applicantFullName"];
            this.applicantPhone = _data["applicantPhone"];
            this.applicantEmail = _data["applicantEmail"];
            this.isExpert = _data["isExpert"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.correctTheoreticalAnswersPercentage = _data["correctTheoreticalAnswersPercentage"];
        }
    }

    static fromJS(data: any): ExamApplication {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["finalized"] = this.finalized;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["examSessionStatus"] = this.examSessionStatus;
        data["recommendations"] = this.recommendations;
        data["examApplicationId"] = this.examApplicationId;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["processedByNark"] = this.processedByNark;
        data["examSessionReadyStatus"] = this.examSessionReadyStatus;
        data["applicantId"] = this.applicantId;
        data["applicantFullName"] = this.applicantFullName;
        data["applicantPhone"] = this.applicantPhone;
        data["applicantEmail"] = this.applicantEmail;
        data["isExpert"] = this.isExpert;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["correctTheoreticalAnswersPercentage"] = this.correctTheoreticalAnswersPercentage;
        return data; 
    }
}

export interface IExamApplication {
    status: ExamApplicationStatus;
    finalized: boolean;
    statusChangeTime: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId: string;
    applicationSubmitDate: moment.Moment;
    /** Обработан в НАРК */
    processedByNark: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    applicantId: string;
    applicantFullName: string;
    applicantPhone: string;
    applicantEmail: string;
    isExpert: boolean;
    birthDate: moment.Moment;
    correctTheoreticalAnswersPercentage?: number | undefined;
}

export class ExamApplicationDetails implements IExamApplicationDetails {
    status!: ExamApplicationStatus;
    finalized!: boolean;
    statusChangeTime!: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId!: string;
    applicationSubmitDate!: moment.Moment;
    /** Обработан в НАРК */
    processedByNark!: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    exam!: Exam;
    applicant!: Applicant;
    applicantIdentityDoc!: ApplicantIdentityDoc;
    documents!: ExamApplicationDocument[];
    reviewComment?: string | undefined;
    agreementUrl?: string | undefined;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl?: string | undefined;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
    certificateDeliveryAddress?: string | undefined;
    isPassedTheory?: boolean | undefined;
    signCode?: string | undefined;
    approveCode?: string | undefined;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamApplicationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.exam = new Exam();
            this.applicant = new Applicant();
            this.applicantIdentityDoc = new ApplicantIdentityDoc();
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.finalized = _data["finalized"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.examSessionStatus = _data["examSessionStatus"];
            this.recommendations = _data["recommendations"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.processedByNark = _data["processedByNark"];
            this.examSessionReadyStatus = _data["examSessionReadyStatus"];
            this.exam = _data["exam"] ? Exam.fromJS(_data["exam"]) : new Exam();
            this.applicant = _data["applicant"] ? Applicant.fromJS(_data["applicant"]) : new Applicant();
            this.applicantIdentityDoc = _data["applicantIdentityDoc"] ? ApplicantIdentityDoc.fromJS(_data["applicantIdentityDoc"]) : new ApplicantIdentityDoc();
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ExamApplicationDocument.fromJS(item));
            }
            this.reviewComment = _data["reviewComment"];
            this.agreementUrl = _data["agreementUrl"];
            this.narkPageUrl = _data["narkPageUrl"];
            this.certificateUrl = _data["certificateUrl"];
            this.certificateDeliveryAddress = _data["certificateDeliveryAddress"];
            this.isPassedTheory = _data["isPassedTheory"];
            this.signCode = _data["signCode"];
            this.approveCode = _data["approveCode"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamApplicationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["finalized"] = this.finalized;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["examSessionStatus"] = this.examSessionStatus;
        data["recommendations"] = this.recommendations;
        data["examApplicationId"] = this.examApplicationId;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["processedByNark"] = this.processedByNark;
        data["examSessionReadyStatus"] = this.examSessionReadyStatus;
        data["exam"] = this.exam ? this.exam.toJSON() : <any>undefined;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["applicantIdentityDoc"] = this.applicantIdentityDoc ? this.applicantIdentityDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["reviewComment"] = this.reviewComment;
        data["agreementUrl"] = this.agreementUrl;
        data["narkPageUrl"] = this.narkPageUrl;
        data["certificateUrl"] = this.certificateUrl;
        data["certificateDeliveryAddress"] = this.certificateDeliveryAddress;
        data["isPassedTheory"] = this.isPassedTheory;
        data["signCode"] = this.signCode;
        data["approveCode"] = this.approveCode;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamApplicationDetails {
    status: ExamApplicationStatus;
    finalized: boolean;
    statusChangeTime: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId: string;
    applicationSubmitDate: moment.Moment;
    /** Обработан в НАРК */
    processedByNark: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    exam: Exam;
    applicant: Applicant;
    applicantIdentityDoc: ApplicantIdentityDoc;
    documents: ExamApplicationDocument[];
    reviewComment?: string | undefined;
    agreementUrl?: string | undefined;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl?: string | undefined;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
    certificateDeliveryAddress?: string | undefined;
    isPassedTheory?: boolean | undefined;
    signCode?: string | undefined;
    approveCode?: string | undefined;
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamApplicationDocument implements IExamApplicationDocument {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    id!: string;
    documentDescription!: string;
    variant!: number;
    type!: DocumentType;
    documentTemplateId?: string | undefined;
    examApplicationId!: string;
    applicantId!: string;
    submissionDate!: moment.Moment;
    readonly sourceFiles!: SourceFile[];

    constructor(data?: IExamApplicationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sourceFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.id = _data["id"];
            this.documentDescription = _data["documentDescription"];
            this.variant = _data["variant"];
            this.type = _data["type"];
            this.documentTemplateId = _data["documentTemplateId"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicantId = _data["applicantId"];
            this.submissionDate = _data["submissionDate"] ? moment(_data["submissionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["sourceFiles"])) {
                (<any>this).sourceFiles = [] as any;
                for (let item of _data["sourceFiles"])
                    (<any>this).sourceFiles!.push(SourceFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamApplicationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["id"] = this.id;
        data["documentDescription"] = this.documentDescription;
        data["variant"] = this.variant;
        data["type"] = this.type;
        data["documentTemplateId"] = this.documentTemplateId;
        data["examApplicationId"] = this.examApplicationId;
        data["applicantId"] = this.applicantId;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.sourceFiles)) {
            data["sourceFiles"] = [];
            for (let item of this.sourceFiles)
                data["sourceFiles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExamApplicationDocument {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    id: string;
    documentDescription: string;
    variant: number;
    type: DocumentType;
    documentTemplateId?: string | undefined;
    examApplicationId: string;
    applicantId: string;
    submissionDate: moment.Moment;
    sourceFiles: SourceFile[];
}

export class ExamApplicationList implements IExamApplicationList {
    items!: ExamApplication[];
    page!: number;
    pageSize!: number;
    total!: number;
    admittedCount!: number;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamApplicationList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExamApplication.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
            this.admittedCount = _data["admittedCount"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamApplicationList {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        data["admittedCount"] = this.admittedCount;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamApplicationList {
    items: ExamApplication[];
    page: number;
    pageSize: number;
    total: number;
    admittedCount: number;
    eventsState?: { [key: string]: number; } | undefined;
}

export enum ExamApplicationStatus {
    Draft = "draft",
    InReview = "inReview",
    CorrectionsRequired = "correctionsRequired",
    PaymentRequired = "paymentRequired",
    Canceled = "canceled",
    Paid = "paid",
    AdmittedToExam = "admittedToExam",
    IsPassing = "isPassing",
    Absent = "absent",
    NotPassed = "notPassed",
    Passed = "passed",
}

export class ExamDetails implements IExamDetails {
    id!: string;
    date!: moment.Moment;
    qualificationId!: string;
    examinationCenterId!: string;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    qualificationEvaluationCenterName!: string;
    examinationCenterName!: string;
    address!: string;
    city!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration!: number;
    price!: number;
    /** Переаттестация */
    recertification!: boolean;
    type!: ExamType;
    qualificationEvaluationCenterId!: string;
    numberOfApplicants!: number;
    protocolNumber?: number | undefined;
    /** Список экспертов экзаменационной комиссии / подписантов протокола НОК */
    experts!: ExamExpert[];
    /** Список подписантов протокола АК */
    akExperts!: ExamExpert[];
    /** Список подписантов протокола совета */
    sovietExperts!: ExamExpert[];
    actualStartTime?: moment.Moment | undefined;
    actualFinishTime?: moment.Moment | undefined;
    manualCheck!: boolean;
    examLogs!: ExamLog[];
    nokProtocolUrl?: string | undefined;
    akProtocolUrl?: string | undefined;
    sovietProtocolUrl?: string | undefined;
    rules?: string | undefined;
    theoreticalQuestionsCount!: number;
    theoreticalPartDuration!: number;
    practicalQuestionsCount!: number;
    practicalPartDuration!: number;
    protocolDate?: moment.Moment | undefined;
    practiceDefense!: boolean;
    /** Количество мест */
    applicationsLimit?: number | undefined;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.experts = [];
            this.akExperts = [];
            this.sovietExperts = [];
            this.examLogs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.examinationCenterId = _data["examinationCenterId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.recertification = _data["recertification"];
            this.type = _data["type"];
            this.qualificationEvaluationCenterId = _data["qualificationEvaluationCenterId"];
            this.numberOfApplicants = _data["numberOfApplicants"];
            this.protocolNumber = _data["protocolNumber"];
            if (Array.isArray(_data["experts"])) {
                this.experts = [] as any;
                for (let item of _data["experts"])
                    this.experts!.push(ExamExpert.fromJS(item));
            }
            if (Array.isArray(_data["akExperts"])) {
                this.akExperts = [] as any;
                for (let item of _data["akExperts"])
                    this.akExperts!.push(ExamExpert.fromJS(item));
            }
            if (Array.isArray(_data["sovietExperts"])) {
                this.sovietExperts = [] as any;
                for (let item of _data["sovietExperts"])
                    this.sovietExperts!.push(ExamExpert.fromJS(item));
            }
            this.actualStartTime = _data["actualStartTime"] ? moment(_data["actualStartTime"].toString()) : <any>undefined;
            this.actualFinishTime = _data["actualFinishTime"] ? moment(_data["actualFinishTime"].toString()) : <any>undefined;
            this.manualCheck = _data["manualCheck"];
            if (Array.isArray(_data["examLogs"])) {
                this.examLogs = [] as any;
                for (let item of _data["examLogs"])
                    this.examLogs!.push(ExamLog.fromJS(item));
            }
            this.nokProtocolUrl = _data["nokProtocolUrl"];
            this.akProtocolUrl = _data["akProtocolUrl"];
            this.sovietProtocolUrl = _data["sovietProtocolUrl"];
            this.rules = _data["rules"];
            this.theoreticalQuestionsCount = _data["theoreticalQuestionsCount"];
            this.theoreticalPartDuration = _data["theoreticalPartDuration"];
            this.practicalQuestionsCount = _data["practicalQuestionsCount"];
            this.practicalPartDuration = _data["practicalPartDuration"];
            this.protocolDate = _data["protocolDate"] ? moment(_data["protocolDate"].toString()) : <any>undefined;
            this.practiceDefense = _data["practiceDefense"];
            this.applicationsLimit = _data["applicationsLimit"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["examinationCenterId"] = this.examinationCenterId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["recertification"] = this.recertification;
        data["type"] = this.type;
        data["qualificationEvaluationCenterId"] = this.qualificationEvaluationCenterId;
        data["numberOfApplicants"] = this.numberOfApplicants;
        data["protocolNumber"] = this.protocolNumber;
        if (Array.isArray(this.experts)) {
            data["experts"] = [];
            for (let item of this.experts)
                data["experts"].push(item.toJSON());
        }
        if (Array.isArray(this.akExperts)) {
            data["akExperts"] = [];
            for (let item of this.akExperts)
                data["akExperts"].push(item.toJSON());
        }
        if (Array.isArray(this.sovietExperts)) {
            data["sovietExperts"] = [];
            for (let item of this.sovietExperts)
                data["sovietExperts"].push(item.toJSON());
        }
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data["actualFinishTime"] = this.actualFinishTime ? this.actualFinishTime.toISOString() : <any>undefined;
        data["manualCheck"] = this.manualCheck;
        if (Array.isArray(this.examLogs)) {
            data["examLogs"] = [];
            for (let item of this.examLogs)
                data["examLogs"].push(item.toJSON());
        }
        data["nokProtocolUrl"] = this.nokProtocolUrl;
        data["akProtocolUrl"] = this.akProtocolUrl;
        data["sovietProtocolUrl"] = this.sovietProtocolUrl;
        data["rules"] = this.rules;
        data["theoreticalQuestionsCount"] = this.theoreticalQuestionsCount;
        data["theoreticalPartDuration"] = this.theoreticalPartDuration;
        data["practicalQuestionsCount"] = this.practicalQuestionsCount;
        data["practicalPartDuration"] = this.practicalPartDuration;
        data["protocolDate"] = this.protocolDate ? this.protocolDate.toISOString() : <any>undefined;
        data["practiceDefense"] = this.practiceDefense;
        data["applicationsLimit"] = this.applicationsLimit;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamDetails {
    id: string;
    date: moment.Moment;
    qualificationId: string;
    examinationCenterId: string;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    qualificationEvaluationCenterName: string;
    examinationCenterName: string;
    address: string;
    city: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration: number;
    price: number;
    /** Переаттестация */
    recertification: boolean;
    type: ExamType;
    qualificationEvaluationCenterId: string;
    numberOfApplicants: number;
    protocolNumber?: number | undefined;
    /** Список экспертов экзаменационной комиссии / подписантов протокола НОК */
    experts: ExamExpert[];
    /** Список подписантов протокола АК */
    akExperts: ExamExpert[];
    /** Список подписантов протокола совета */
    sovietExperts: ExamExpert[];
    actualStartTime?: moment.Moment | undefined;
    actualFinishTime?: moment.Moment | undefined;
    manualCheck: boolean;
    examLogs: ExamLog[];
    nokProtocolUrl?: string | undefined;
    akProtocolUrl?: string | undefined;
    sovietProtocolUrl?: string | undefined;
    rules?: string | undefined;
    theoreticalQuestionsCount: number;
    theoreticalPartDuration: number;
    practicalQuestionsCount: number;
    practicalPartDuration: number;
    protocolDate?: moment.Moment | undefined;
    practiceDefense: boolean;
    /** Количество мест */
    applicationsLimit?: number | undefined;
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamExpert implements IExamExpert {
    regNumber!: string;
    expertId!: string;
    fullName!: string;
    email!: string;
    phone!: string;
    region!: string;
    /** Эксперт доступен для подписи протокола */
    active!: boolean;
    /** Протокол пописан экспертом */
    signed!: boolean;
    chairman!: boolean;
    acceptedInvite?: boolean | undefined;
    position?: string | undefined;
    signedCode?: string | undefined;

    constructor(data?: IExamExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regNumber = _data["regNumber"];
            this.expertId = _data["expertId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.region = _data["region"];
            this.active = _data["active"];
            this.signed = _data["signed"];
            this.chairman = _data["chairman"];
            this.acceptedInvite = _data["acceptedInvite"];
            this.position = _data["position"];
            this.signedCode = _data["signedCode"];
        }
    }

    static fromJS(data: any): ExamExpert {
        data = typeof data === 'object' ? data : {};
        let result = new ExamExpert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regNumber"] = this.regNumber;
        data["expertId"] = this.expertId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["region"] = this.region;
        data["active"] = this.active;
        data["signed"] = this.signed;
        data["chairman"] = this.chairman;
        data["acceptedInvite"] = this.acceptedInvite;
        data["position"] = this.position;
        data["signedCode"] = this.signedCode;
        return data; 
    }
}

export interface IExamExpert {
    regNumber: string;
    expertId: string;
    fullName: string;
    email: string;
    phone: string;
    region: string;
    /** Эксперт доступен для подписи протокола */
    active: boolean;
    /** Протокол пописан экспертом */
    signed: boolean;
    chairman: boolean;
    acceptedInvite?: boolean | undefined;
    position?: string | undefined;
    signedCode?: string | undefined;
}

export class ExaminationCenter implements IExaminationCenter {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    city!: string;
    address!: string;
    /** Id региона */
    regionId!: number;
    host!: string;
    default!: boolean;

    constructor(data?: IExaminationCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.host = _data["host"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): ExaminationCenter {
        data = typeof data === 'object' ? data : {};
        let result = new ExaminationCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["host"] = this.host;
        data["default"] = this.default;
        return data; 
    }
}

export interface IExaminationCenter {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    city: string;
    address: string;
    /** Id региона */
    regionId: number;
    host: string;
    default: boolean;
}

export class ExaminationCentersList implements IExaminationCentersList {
    items!: ExaminationCenter[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IExaminationCentersList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExaminationCenter.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ExaminationCentersList {
        data = typeof data === 'object' ? data : {};
        let result = new ExaminationCentersList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IExaminationCentersList {
    items: ExaminationCenter[];
    page: number;
    pageSize: number;
    total: number;
}

export class ExamList implements IExamList {
    items!: Exam[];
    page!: number;
    pageSize!: number;
    total!: number;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Exam.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamList {
        data = typeof data === 'object' ? data : {};
        let result = new ExamList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamList {
    items: Exam[];
    page: number;
    pageSize: number;
    total: number;
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamLog implements IExamLog {
    statusText!: string;
    time!: moment.Moment;

    constructor(data?: IExamLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusText = _data["statusText"];
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExamLog {
        data = typeof data === 'object' ? data : {};
        let result = new ExamLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusText"] = this.statusText;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IExamLog {
    statusText: string;
    time: moment.Moment;
}

export class ExamSessionDetails implements IExamSessionDetails {
    readonly examApplicationId!: string;
    readonly applicantId!: string;
    id!: string;
    examId!: string;
    startTime!: moment.Moment;
    readonly theoryFinishTime?: moment.Moment | undefined;
    readonly practiceStartTime?: moment.Moment | undefined;
    isPassedTheory!: boolean;
    readonly passed?: boolean | undefined;
    readonly finishTime?: moment.Moment | undefined;
    totalTimeInMinutes!: number;
    readonly theoreticalPassPercentage!: number;
    readonly totalPassPercentage!: number;
    readonly correctTheoreticalAnswersPercentage!: number;
    theoreticalPartDuration!: number;
    practicalPartDuration!: number;
    readonly isPassedPractice?: boolean | undefined;
    readonly correctPracticalAnswersPercentage!: number;
    readonly factualTheoreticalQuestionAnswers!: FactualTheoreticalQuestionAnswer[];
    readonly factualPracticalQuestionAnswers!: FactualPracticalQuestionAnswer[];
    manualCheck!: boolean;
    theoreticalQuestions!: TheoreticalQuestion[];
    practicalQuestions?: PracticalQuestion[] | undefined;
    readonly criteriaForRate?: string | undefined;

    constructor(data?: IExamSessionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.factualTheoreticalQuestionAnswers = [];
            this.factualPracticalQuestionAnswers = [];
            this.theoreticalQuestions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).examApplicationId = _data["examApplicationId"];
            (<any>this).applicantId = _data["applicantId"];
            this.id = _data["id"];
            this.examId = _data["examId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            (<any>this).theoryFinishTime = _data["theoryFinishTime"] ? moment(_data["theoryFinishTime"].toString()) : <any>undefined;
            (<any>this).practiceStartTime = _data["practiceStartTime"] ? moment(_data["practiceStartTime"].toString()) : <any>undefined;
            this.isPassedTheory = _data["isPassedTheory"];
            (<any>this).passed = _data["passed"];
            (<any>this).finishTime = _data["finishTime"] ? moment(_data["finishTime"].toString()) : <any>undefined;
            this.totalTimeInMinutes = _data["totalTimeInMinutes"];
            (<any>this).theoreticalPassPercentage = _data["theoreticalPassPercentage"];
            (<any>this).totalPassPercentage = _data["totalPassPercentage"];
            (<any>this).correctTheoreticalAnswersPercentage = _data["correctTheoreticalAnswersPercentage"];
            this.theoreticalPartDuration = _data["theoreticalPartDuration"];
            this.practicalPartDuration = _data["practicalPartDuration"];
            (<any>this).isPassedPractice = _data["isPassedPractice"];
            (<any>this).correctPracticalAnswersPercentage = _data["correctPracticalAnswersPercentage"];
            if (Array.isArray(_data["factualTheoreticalQuestionAnswers"])) {
                (<any>this).factualTheoreticalQuestionAnswers = [] as any;
                for (let item of _data["factualTheoreticalQuestionAnswers"])
                    (<any>this).factualTheoreticalQuestionAnswers!.push(FactualTheoreticalQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["factualPracticalQuestionAnswers"])) {
                (<any>this).factualPracticalQuestionAnswers = [] as any;
                for (let item of _data["factualPracticalQuestionAnswers"])
                    (<any>this).factualPracticalQuestionAnswers!.push(FactualPracticalQuestionAnswer.fromJS(item));
            }
            this.manualCheck = _data["manualCheck"];
            if (Array.isArray(_data["theoreticalQuestions"])) {
                this.theoreticalQuestions = [] as any;
                for (let item of _data["theoreticalQuestions"])
                    this.theoreticalQuestions!.push(TheoreticalQuestion.fromJS(item));
            }
            if (Array.isArray(_data["practicalQuestions"])) {
                this.practicalQuestions = [] as any;
                for (let item of _data["practicalQuestions"])
                    this.practicalQuestions!.push(PracticalQuestion.fromJS(item));
            }
            (<any>this).criteriaForRate = _data["criteriaForRate"];
        }
    }

    static fromJS(data: any): ExamSessionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamSessionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examApplicationId"] = this.examApplicationId;
        data["applicantId"] = this.applicantId;
        data["id"] = this.id;
        data["examId"] = this.examId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["theoryFinishTime"] = this.theoryFinishTime ? this.theoryFinishTime.toISOString() : <any>undefined;
        data["practiceStartTime"] = this.practiceStartTime ? this.practiceStartTime.toISOString() : <any>undefined;
        data["isPassedTheory"] = this.isPassedTheory;
        data["passed"] = this.passed;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["totalTimeInMinutes"] = this.totalTimeInMinutes;
        data["theoreticalPassPercentage"] = this.theoreticalPassPercentage;
        data["totalPassPercentage"] = this.totalPassPercentage;
        data["correctTheoreticalAnswersPercentage"] = this.correctTheoreticalAnswersPercentage;
        data["theoreticalPartDuration"] = this.theoreticalPartDuration;
        data["practicalPartDuration"] = this.practicalPartDuration;
        data["isPassedPractice"] = this.isPassedPractice;
        data["correctPracticalAnswersPercentage"] = this.correctPracticalAnswersPercentage;
        if (Array.isArray(this.factualTheoreticalQuestionAnswers)) {
            data["factualTheoreticalQuestionAnswers"] = [];
            for (let item of this.factualTheoreticalQuestionAnswers)
                data["factualTheoreticalQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.factualPracticalQuestionAnswers)) {
            data["factualPracticalQuestionAnswers"] = [];
            for (let item of this.factualPracticalQuestionAnswers)
                data["factualPracticalQuestionAnswers"].push(item.toJSON());
        }
        data["manualCheck"] = this.manualCheck;
        if (Array.isArray(this.theoreticalQuestions)) {
            data["theoreticalQuestions"] = [];
            for (let item of this.theoreticalQuestions)
                data["theoreticalQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.practicalQuestions)) {
            data["practicalQuestions"] = [];
            for (let item of this.practicalQuestions)
                data["practicalQuestions"].push(item.toJSON());
        }
        data["criteriaForRate"] = this.criteriaForRate;
        return data; 
    }
}

export interface IExamSessionDetails {
    examApplicationId: string;
    applicantId: string;
    id: string;
    examId: string;
    startTime: moment.Moment;
    theoryFinishTime?: moment.Moment | undefined;
    practiceStartTime?: moment.Moment | undefined;
    isPassedTheory: boolean;
    passed?: boolean | undefined;
    finishTime?: moment.Moment | undefined;
    totalTimeInMinutes: number;
    theoreticalPassPercentage: number;
    totalPassPercentage: number;
    correctTheoreticalAnswersPercentage: number;
    theoreticalPartDuration: number;
    practicalPartDuration: number;
    isPassedPractice?: boolean | undefined;
    correctPracticalAnswersPercentage: number;
    factualTheoreticalQuestionAnswers: FactualTheoreticalQuestionAnswer[];
    factualPracticalQuestionAnswers: FactualPracticalQuestionAnswer[];
    manualCheck: boolean;
    theoreticalQuestions: TheoreticalQuestion[];
    practicalQuestions?: PracticalQuestion[] | undefined;
    criteriaForRate?: string | undefined;
}

export enum ExamSessionReadyStatuses {
    WaitingForStart = "waitingForStart",
    ExamIsPassing = "examIsPassing",
    TheoreticalExamIsPassingAndSessionStarted = "theoreticalExamIsPassingAndSessionStarted",
    ExamSessionTimeout = "examSessionTimeout",
    PracticalExamIsPassingAndSessionStarted = "practicalExamIsPassingAndSessionStarted",
    ExamFinished = "examFinished",
    SessionFinished = "sessionFinished",
}

export enum ExamSessionStatus {
    Active = "active",
    Completed = "completed",
}

export enum ExamSignatureType {
    NokAcceptance = "nokAcceptance",
    AkAcceptance = "akAcceptance",
    SovietAcceptance = "sovietAcceptance",
}

export enum ExamStatus {
    AwaitingExpertConfirmation = "awaitingExpertConfirmation",
    IsApplying = "isApplying",
    ApplyingFinished = "applyingFinished",
    Canceled = "canceled",
    IsPassing = "isPassing",
    Finishing = "finishing",
    Finished = "finished",
    FinalizedResults = "finalizedResults",
    NokProtocolSigned = "nokProtocolSigned",
    AkProtocolSigned = "akProtocolSigned",
    SovietProtocolSignedByMembers = "sovietProtocolSignedByMembers",
    SovietProtocolSignedByChairman = "sovietProtocolSignedByChairman",
}

export enum ExamType {
    Intramural = "intramural",
    Recertification = "recertification",
    Online = "online",
}

export class Expert implements IExpert {
    id!: string;
    regNumber!: string;
    firstName!: string;
    lastName!: string;
    middleName!: string;
    birthDate!: moment.Moment;
    sex!: Sex;
    phone!: string;
    email!: string;
    regionId!: number;
    region!: string;
    sovietMember!: boolean;
    akMember!: boolean;
    nokMember!: boolean;
    chairman!: boolean;
    employee?: boolean | undefined;
    emailConfirmed!: boolean;
    registrationCompleted!: boolean;
    /** Должность в случае члена совета */
    position?: string | undefined;
    applicantId?: string | undefined;

    constructor(data?: IExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.regionId = _data["regionId"];
            this.region = _data["region"];
            this.sovietMember = _data["sovietMember"];
            this.akMember = _data["akMember"];
            this.nokMember = _data["nokMember"];
            this.chairman = _data["chairman"];
            this.employee = _data["employee"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.registrationCompleted = _data["registrationCompleted"];
            this.position = _data["position"];
            this.applicantId = _data["applicantId"];
        }
    }

    static fromJS(data: any): Expert {
        data = typeof data === 'object' ? data : {};
        let result = new Expert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionId"] = this.regionId;
        data["region"] = this.region;
        data["sovietMember"] = this.sovietMember;
        data["akMember"] = this.akMember;
        data["nokMember"] = this.nokMember;
        data["chairman"] = this.chairman;
        data["employee"] = this.employee;
        data["emailConfirmed"] = this.emailConfirmed;
        data["registrationCompleted"] = this.registrationCompleted;
        data["position"] = this.position;
        data["applicantId"] = this.applicantId;
        return data; 
    }
}

export interface IExpert {
    id: string;
    regNumber: string;
    firstName: string;
    lastName: string;
    middleName: string;
    birthDate: moment.Moment;
    sex: Sex;
    phone: string;
    email: string;
    regionId: number;
    region: string;
    sovietMember: boolean;
    akMember: boolean;
    nokMember: boolean;
    chairman: boolean;
    employee?: boolean | undefined;
    emailConfirmed: boolean;
    registrationCompleted: boolean;
    /** Должность в случае члена совета */
    position?: string | undefined;
    applicantId?: string | undefined;
}

export class ExpertCertificate implements IExpertCertificate {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    id!: string;
    /** Регистрационный номер */
    regNumber!: string;
    /** Дата выдачи */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;

    constructor(data?: IExpertCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpertCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IExpertCertificate {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    id: string;
    /** Регистрационный номер */
    regNumber: string;
    /** Дата выдачи */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
}

export class ExpertConfirmationData implements IExpertConfirmationData {
    firstName!: string;
    lastName!: string;
    middleName!: string;
    phone!: string;
    email!: string;

    constructor(data?: IExpertConfirmationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ExpertConfirmationData {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertConfirmationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data; 
    }
}

export interface IExpertConfirmationData {
    firstName: string;
    lastName: string;
    middleName: string;
    phone: string;
    email: string;
}

export class ExpertEc implements IExpertEc {
    ecId!: string;
    ecRegNumber!: string;
    ecName!: string;
    ecCity!: string;
    expertIsEmployee!: boolean;
    assigned!: boolean;

    constructor(data?: IExpertEc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ecId = _data["ecId"];
            this.ecRegNumber = _data["ecRegNumber"];
            this.ecName = _data["ecName"];
            this.ecCity = _data["ecCity"];
            this.expertIsEmployee = _data["expertIsEmployee"];
            this.assigned = _data["assigned"];
        }
    }

    static fromJS(data: any): ExpertEc {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertEc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ecId"] = this.ecId;
        data["ecRegNumber"] = this.ecRegNumber;
        data["ecName"] = this.ecName;
        data["ecCity"] = this.ecCity;
        data["expertIsEmployee"] = this.expertIsEmployee;
        data["assigned"] = this.assigned;
        return data; 
    }
}

export interface IExpertEc {
    ecId: string;
    ecRegNumber: string;
    ecName: string;
    ecCity: string;
    expertIsEmployee: boolean;
    assigned: boolean;
}

export class ExpertEcs implements IExpertEcs {
    items!: ExpertEc[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IExpertEcs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExpertEc.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ExpertEcs {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertEcs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IExpertEcs {
    items: ExpertEc[];
    page: number;
    pageSize: number;
    total: number;
}

export class FactualPracticalQuestionAnswer implements IFactualPracticalQuestionAnswer {
    readonly questionId!: string;
    readonly criteriaForRate?: string | undefined;
    type!: PracticalQuestionType;
    readonly correct?: boolean | undefined;
    essayAnswer?: EssayAnswer;
    openAnswerAnswer?: OpenAnswerAnswer;
    tabularAnswer?: CheckedTable[] | undefined;

    constructor(data?: IFactualPracticalQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).questionId = _data["questionId"];
            (<any>this).criteriaForRate = _data["criteriaForRate"];
            this.type = _data["type"];
            (<any>this).correct = _data["correct"];
            this.essayAnswer = _data["essayAnswer"] ? EssayAnswer.fromJS(_data["essayAnswer"]) : <any>undefined;
            this.openAnswerAnswer = _data["openAnswerAnswer"] ? OpenAnswerAnswer.fromJS(_data["openAnswerAnswer"]) : <any>undefined;
            if (Array.isArray(_data["tabularAnswer"])) {
                this.tabularAnswer = [] as any;
                for (let item of _data["tabularAnswer"])
                    this.tabularAnswer!.push(CheckedTable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FactualPracticalQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new FactualPracticalQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["criteriaForRate"] = this.criteriaForRate;
        data["type"] = this.type;
        data["correct"] = this.correct;
        data["essayAnswer"] = this.essayAnswer ? this.essayAnswer.toJSON() : <any>undefined;
        data["openAnswerAnswer"] = this.openAnswerAnswer ? this.openAnswerAnswer.toJSON() : <any>undefined;
        if (Array.isArray(this.tabularAnswer)) {
            data["tabularAnswer"] = [];
            for (let item of this.tabularAnswer)
                data["tabularAnswer"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFactualPracticalQuestionAnswer {
    questionId: string;
    criteriaForRate?: string | undefined;
    type: PracticalQuestionType;
    correct?: boolean | undefined;
    essayAnswer?: EssayAnswer;
    openAnswerAnswer?: OpenAnswerAnswer;
    tabularAnswer?: CheckedTable[] | undefined;
}

export class FactualTheoreticalQuestionAnswer implements IFactualTheoreticalQuestionAnswer {
    readonly questionId!: string;
    readonly correct!: boolean;
    readonly correctAnswersNumbers!: AnswerPair[];
    readonly factualAnswersNumbers!: AnswerPair[];
    readonly correctAnswer?: string | undefined;
    readonly factualAnswer?: string | undefined;

    constructor(data?: IFactualTheoreticalQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.correctAnswersNumbers = [];
            this.factualAnswersNumbers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).questionId = _data["questionId"];
            (<any>this).correct = _data["correct"];
            if (Array.isArray(_data["correctAnswersNumbers"])) {
                (<any>this).correctAnswersNumbers = [] as any;
                for (let item of _data["correctAnswersNumbers"])
                    (<any>this).correctAnswersNumbers!.push(AnswerPair.fromJS(item));
            }
            if (Array.isArray(_data["factualAnswersNumbers"])) {
                (<any>this).factualAnswersNumbers = [] as any;
                for (let item of _data["factualAnswersNumbers"])
                    (<any>this).factualAnswersNumbers!.push(AnswerPair.fromJS(item));
            }
            (<any>this).correctAnswer = _data["correctAnswer"];
            (<any>this).factualAnswer = _data["factualAnswer"];
        }
    }

    static fromJS(data: any): FactualTheoreticalQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new FactualTheoreticalQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["correct"] = this.correct;
        if (Array.isArray(this.correctAnswersNumbers)) {
            data["correctAnswersNumbers"] = [];
            for (let item of this.correctAnswersNumbers)
                data["correctAnswersNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.factualAnswersNumbers)) {
            data["factualAnswersNumbers"] = [];
            for (let item of this.factualAnswersNumbers)
                data["factualAnswersNumbers"].push(item.toJSON());
        }
        data["correctAnswer"] = this.correctAnswer;
        data["factualAnswer"] = this.factualAnswer;
        return data; 
    }
}

export interface IFactualTheoreticalQuestionAnswer {
    questionId: string;
    correct: boolean;
    correctAnswersNumbers: AnswerPair[];
    factualAnswersNumbers: AnswerPair[];
    correctAnswer?: string | undefined;
    factualAnswer?: string | undefined;
}

export enum FilteredExamStatus {
    AwaitingExpertConfirmation = "awaitingExpertConfirmation",
    IsApplying = "isApplying",
    ApplyingFinished = "applyingFinished",
    IsPassing = "isPassing",
    Finished = "finished",
    FinalizedResults = "finalizedResults",
    NokProtocolSigned = "nokProtocolSigned",
    AkProtocolSigned = "akProtocolSigned",
    Processed = "processed",
    Canceled = "canceled",
}

export enum IdentityDocType {
    Passport = "passport",
    Other = "other",
}

export class LoginExpert implements ILoginExpert {
    captcha?: string | undefined;
    phone!: string;
    password!: string;

    constructor(data?: ILoginExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginExpert {
        data = typeof data === 'object' ? data : {};
        let result = new LoginExpert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginExpert {
    captcha?: string | undefined;
    phone: string;
    password: string;
}

export class OpenAnswerAnswer implements IOpenAnswerAnswer {
    correct!: string;
    factual?: string | undefined;

    constructor(data?: IOpenAnswerAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correct = _data["correct"];
            this.factual = _data["factual"];
        }
    }

    static fromJS(data: any): OpenAnswerAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new OpenAnswerAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["correct"] = this.correct;
        data["factual"] = this.factual;
        return data; 
    }
}

export interface IOpenAnswerAnswer {
    correct: string;
    factual?: string | undefined;
}

export class PracticalQuestion implements IPracticalQuestion {
    /** Id вопроса */
    id!: string;
    /** Текст вопроса, в виде HTML */
    text!: string;
    type!: PracticalQuestionType;
    /** Таблицы для табличного вопроса */
    tabularQuestionTables?: Table[] | undefined;

    constructor(data?: IPracticalQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.type = _data["type"];
            if (Array.isArray(_data["tabularQuestionTables"])) {
                this.tabularQuestionTables = [] as any;
                for (let item of _data["tabularQuestionTables"])
                    this.tabularQuestionTables!.push(Table.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PracticalQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new PracticalQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["type"] = this.type;
        if (Array.isArray(this.tabularQuestionTables)) {
            data["tabularQuestionTables"] = [];
            for (let item of this.tabularQuestionTables)
                data["tabularQuestionTables"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPracticalQuestion {
    /** Id вопроса */
    id: string;
    /** Текст вопроса, в виде HTML */
    text: string;
    type: PracticalQuestionType;
    /** Таблицы для табличного вопроса */
    tabularQuestionTables?: Table[] | undefined;
}

export enum PracticalQuestionType {
    OpenAnswer = "openAnswer",
    Essay = "essay",
    ManualCheckTabular = "manualCheckTabular",
    AutoCheckTabular = "autoCheckTabular",
    Offline = "offline",
}

export class QualificationInfo implements IQualificationInfo {
    id!: string;
    title!: string;
    level!: string;
    regNumber!: string;
    occupationalStandardId!: string;
    occupationalStandardTitle!: string;
    readyToUse!: boolean;

    constructor(data?: IQualificationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.occupationalStandardId = _data["occupationalStandardId"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.readyToUse = _data["readyToUse"];
        }
    }

    static fromJS(data: any): QualificationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["occupationalStandardId"] = this.occupationalStandardId;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["readyToUse"] = this.readyToUse;
        return data; 
    }
}

export interface IQualificationInfo {
    id: string;
    title: string;
    level: string;
    regNumber: string;
    occupationalStandardId: string;
    occupationalStandardTitle: string;
    readyToUse: boolean;
}

export class QualificationInfoList implements IQualificationInfoList {
    items!: QualificationInfo[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IQualificationInfoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QualificationInfo.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): QualificationInfoList {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationInfoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IQualificationInfoList {
    items: QualificationInfo[];
    page: number;
    pageSize: number;
    total: number;
}

export class Rate implements IRate {
    examApplicationId!: string;
    passed!: boolean;
    /** Заполняется в случае несдачи */
    recommendations?: string | undefined;

    constructor(data?: IRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examApplicationId = _data["examApplicationId"];
            this.passed = _data["passed"];
            this.recommendations = _data["recommendations"];
        }
    }

    static fromJS(data: any): Rate {
        data = typeof data === 'object' ? data : {};
        let result = new Rate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examApplicationId"] = this.examApplicationId;
        data["passed"] = this.passed;
        data["recommendations"] = this.recommendations;
        return data; 
    }
}

export interface IRate {
    examApplicationId: string;
    passed: boolean;
    /** Заполняется в случае несдачи */
    recommendations?: string | undefined;
}

export class ResetPassword implements IResetPassword {
    captcha?: string | undefined;
    /** Код верификации */
    verificationCode!: string;
    /** Номер телефона соискателя */
    phone!: string;
    /** Новый пароль */
    newPassword!: string;

    constructor(data?: IResetPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.verificationCode = _data["verificationCode"];
            this.phone = _data["phone"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPassword {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["verificationCode"] = this.verificationCode;
        data["phone"] = this.phone;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IResetPassword {
    captcha?: string | undefined;
    /** Код верификации */
    verificationCode: string;
    /** Номер телефона соискателя */
    phone: string;
    /** Новый пароль */
    newPassword: string;
}

export class SendCodeForSignCurrentSovietProtocols implements ISendCodeForSignCurrentSovietProtocols {
    captcha?: string | undefined;

    constructor(data?: ISendCodeForSignCurrentSovietProtocols) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendCodeForSignCurrentSovietProtocols {
        data = typeof data === 'object' ? data : {};
        let result = new SendCodeForSignCurrentSovietProtocols();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendCodeForSignCurrentSovietProtocols {
    captcha?: string | undefined;
}

export class SendConfirmationEmailAgain implements ISendConfirmationEmailAgain {
    captcha?: string | undefined;

    constructor(data?: ISendConfirmationEmailAgain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendConfirmationEmailAgain {
        data = typeof data === 'object' ? data : {};
        let result = new SendConfirmationEmailAgain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendConfirmationEmailAgain {
    captcha?: string | undefined;
}

export class SendSignatureVerificationCode implements ISendSignatureVerificationCode {
    captcha?: string | undefined;

    constructor(data?: ISendSignatureVerificationCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendSignatureVerificationCode {
        data = typeof data === 'object' ? data : {};
        let result = new SendSignatureVerificationCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendSignatureVerificationCode {
    captcha?: string | undefined;
}

export class SendVerificationCode implements ISendVerificationCode {
    captcha?: string | undefined;
    phone!: string;

    constructor(data?: ISendVerificationCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): SendVerificationCode {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface ISendVerificationCode {
    captcha?: string | undefined;
    phone: string;
}

export class SendVerificationCodeForAcceptExamInvite implements ISendVerificationCodeForAcceptExamInvite {
    captcha?: string | undefined;

    constructor(data?: ISendVerificationCodeForAcceptExamInvite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendVerificationCodeForAcceptExamInvite {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCodeForAcceptExamInvite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendVerificationCodeForAcceptExamInvite {
    captcha?: string | undefined;
}

export class SendVerificationCodeForUpdatePhone implements ISendVerificationCodeForUpdatePhone {
    captcha?: string | undefined;
    phone!: string;
    /** Пароль */
    password!: string;

    constructor(data?: ISendVerificationCodeForUpdatePhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SendVerificationCodeForUpdatePhone {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCodeForUpdatePhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data; 
    }
}

export interface ISendVerificationCodeForUpdatePhone {
    captcha?: string | undefined;
    phone: string;
    /** Пароль */
    password: string;
}

export class SetApplicantTempPassword implements ISetApplicantTempPassword {
    /** Новый временный пароль */
    newPassword!: string;

    constructor(data?: ISetApplicantTempPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): SetApplicantTempPassword {
        data = typeof data === 'object' ? data : {};
        let result = new SetApplicantTempPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface ISetApplicantTempPassword {
    /** Новый временный пароль */
    newPassword: string;
}

export enum Sex {
    Male = "male",
    Female = "female",
}

export class SignCurrentSovietProtocols implements ISignCurrentSovietProtocols {
    captcha?: string | undefined;
    code!: string;

    constructor(data?: ISignCurrentSovietProtocols) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): SignCurrentSovietProtocols {
        data = typeof data === 'object' ? data : {};
        let result = new SignCurrentSovietProtocols();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["code"] = this.code;
        return data; 
    }
}

export interface ISignCurrentSovietProtocols {
    captcha?: string | undefined;
    code: string;
}

export class SignExamProtocol implements ISignExamProtocol {
    captcha?: string | undefined;
    code!: string;

    constructor(data?: ISignExamProtocol) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): SignExamProtocol {
        data = typeof data === 'object' ? data : {};
        let result = new SignExamProtocol();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["code"] = this.code;
        return data; 
    }
}

export interface ISignExamProtocol {
    captcha?: string | undefined;
    code: string;
}

export class SourceFile implements ISourceFile {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    fileName?: string | undefined;

    constructor(data?: ISourceFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): SourceFile {
        data = typeof data === 'object' ? data : {};
        let result = new SourceFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface ISourceFile {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    fileName?: string | undefined;
}

export class Table implements ITable {
    caption?: string | undefined;
    columns!: Column[];
    exactEquality!: boolean;
    forbidMoving!: boolean;
    initialRows!: string[][];
    answerRows?: string[][] | undefined;

    constructor(data?: ITable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.columns = [];
            this.initialRows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caption = _data["caption"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Column.fromJS(item));
            }
            this.exactEquality = _data["exactEquality"];
            this.forbidMoving = _data["forbidMoving"];
            if (Array.isArray(_data["initialRows"])) {
                this.initialRows = [] as any;
                for (let item of _data["initialRows"])
                    this.initialRows!.push(item);
            }
            if (Array.isArray(_data["answerRows"])) {
                this.answerRows = [] as any;
                for (let item of _data["answerRows"])
                    this.answerRows!.push(item);
            }
        }
    }

    static fromJS(data: any): Table {
        data = typeof data === 'object' ? data : {};
        let result = new Table();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["exactEquality"] = this.exactEquality;
        data["forbidMoving"] = this.forbidMoving;
        if (Array.isArray(this.initialRows)) {
            data["initialRows"] = [];
            for (let item of this.initialRows)
                data["initialRows"].push(item);
        }
        if (Array.isArray(this.answerRows)) {
            data["answerRows"] = [];
            for (let item of this.answerRows)
                data["answerRows"].push(item);
        }
        return data; 
    }
}

export interface ITable {
    caption?: string | undefined;
    columns: Column[];
    exactEquality: boolean;
    forbidMoving: boolean;
    initialRows: string[][];
    answerRows?: string[][] | undefined;
}

export class TheoreticalAnswer implements ITheoreticalAnswer {
    number!: number;
    text!: string;

    constructor(data?: ITheoreticalAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): TheoreticalAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new TheoreticalAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["text"] = this.text;
        return data; 
    }
}

export interface ITheoreticalAnswer {
    number: number;
    text: string;
}

export class TheoreticalQuestion implements ITheoreticalQuestion {
    /** Id вопроса */
    id!: string;
    /** Текст вопроса, в виде HTML */
    text!: string;
    type!: TheoreticalQuestionType;
    /** Варианты ответов на вопрос */
    answers!: TheoreticalAnswer[];
    /** Варианты ответов для вопросов на сопоставление или с последовательностью */
    matchingAnswers?: TheoreticalAnswer[] | undefined;
    /** Заголовок над вариантами ответов, для вопросов на сопоставление или с последовательностью */
    answersHeader?: string | undefined;
    /** Заголовок над вариантами ответов, для вопросов на сопоставление или с последовательностью */
    matchingAnswersHeader?: string | undefined;

    constructor(data?: ITheoreticalQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.type = _data["type"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(TheoreticalAnswer.fromJS(item));
            }
            if (Array.isArray(_data["matchingAnswers"])) {
                this.matchingAnswers = [] as any;
                for (let item of _data["matchingAnswers"])
                    this.matchingAnswers!.push(TheoreticalAnswer.fromJS(item));
            }
            this.answersHeader = _data["answersHeader"];
            this.matchingAnswersHeader = _data["matchingAnswersHeader"];
        }
    }

    static fromJS(data: any): TheoreticalQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new TheoreticalQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["type"] = this.type;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.matchingAnswers)) {
            data["matchingAnswers"] = [];
            for (let item of this.matchingAnswers)
                data["matchingAnswers"].push(item.toJSON());
        }
        data["answersHeader"] = this.answersHeader;
        data["matchingAnswersHeader"] = this.matchingAnswersHeader;
        return data; 
    }
}

export interface ITheoreticalQuestion {
    /** Id вопроса */
    id: string;
    /** Текст вопроса, в виде HTML */
    text: string;
    type: TheoreticalQuestionType;
    /** Варианты ответов на вопрос */
    answers: TheoreticalAnswer[];
    /** Варианты ответов для вопросов на сопоставление или с последовательностью */
    matchingAnswers?: TheoreticalAnswer[] | undefined;
    /** Заголовок над вариантами ответов, для вопросов на сопоставление или с последовательностью */
    answersHeader?: string | undefined;
    /** Заголовок над вариантами ответов, для вопросов на сопоставление или с последовательностью */
    matchingAnswersHeader?: string | undefined;
}

export enum TheoreticalQuestionType {
    MultipleChoice = "multipleChoice",
    Matching = "matching",
    OpenAnswer = "openAnswer",
    Ordering = "ordering",
}

export class UpdatePhone implements IUpdatePhone {
    /** Номер телефона */
    phone!: string;
    /** Код верификации */
    verificationCode!: string;

    constructor(data?: IUpdatePhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): UpdatePhone {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface IUpdatePhone {
    /** Номер телефона */
    phone: string;
    /** Код верификации */
    verificationCode: string;
}

export class VerificationCodeSendingStatus implements IVerificationCodeSendingStatus {
    /** Были ли отправлен новый код или надо подождать */
    wasSent?: boolean;
    /** Время ожидания отправки нового кода */
    waitingSeconds?: number;

    constructor(data?: IVerificationCodeSendingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wasSent = _data["wasSent"];
            this.waitingSeconds = _data["waitingSeconds"];
        }
    }

    static fromJS(data: any): VerificationCodeSendingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationCodeSendingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wasSent"] = this.wasSent;
        data["waitingSeconds"] = this.waitingSeconds;
        return data; 
    }
}

export interface IVerificationCodeSendingStatus {
    /** Были ли отправлен новый код или надо подождать */
    wasSent?: boolean;
    /** Время ожидания отправки нового кода */
    waitingSeconds?: number;
}

export class WriteRecommendations implements IWriteRecommendations {
    examApplicationId!: string;
    recommendations!: string;

    constructor(data?: IWriteRecommendations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examApplicationId = _data["examApplicationId"];
            this.recommendations = _data["recommendations"];
        }
    }

    static fromJS(data: any): WriteRecommendations {
        data = typeof data === 'object' ? data : {};
        let result = new WriteRecommendations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examApplicationId"] = this.examApplicationId;
        data["recommendations"] = this.recommendations;
        return data; 
    }
}

export interface IWriteRecommendations {
    examApplicationId: string;
    recommendations: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export class ApiClient extends ApiClientBase {
    private http2: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl2: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(baseUrl, http);
        this.http2 = http ? http : <any>window;
        this.baseUrl2 = baseUrl ? baseUrl : "";
    }

    addExpertCertificateFix(regNumber: string, issueDate: moment.Moment, expireDate: moment.Moment, file: File): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl2 + "/api/v1/certificates";

        const content_ = new FormData();

        if (regNumber === null || regNumber === undefined)
            throw new Error("The parameter ‘regNumber’ cannot be null.");
        else
            content_.append("regNumber", regNumber.toString());
            
        if (issueDate === null || issueDate === undefined)
            throw new Error("The parameter ‘issueDate’ cannot be null.");
        else
            content_.append("issueDate", issueDate.toISOString());
                    
        if (expireDate === null || expireDate === undefined)
            throw new Error("The parameter ‘expireDate’ cannot be null.");
        else
            content_.append("expireDate", expireDate.toISOString());
        
        if (file === null || file === undefined)
            throw new Error("The parameter ‘file’ cannot be null.");
        else
            content_.append("file", file, file.name ? file.name : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http2.fetch(url_, options_).then((_response: Response) => {
            return this.processAddExpertCertificate(_response);
        });
    }
    
    updateExpertCertificateFix(certificateId: string, regNumber: string, issueDate: moment.Moment, expireDate: moment.Moment, file: File | undefined): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl2 + "/api/v1/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();

        if (regNumber === null || regNumber === undefined)
            throw new Error("The parameter ‘regNumber’ cannot be null.");
        else
            content_.append("regNumber", regNumber.toString());
            
        if (issueDate === null || issueDate === undefined)
            throw new Error("The parameter ‘issueDate’ cannot be null.");
        else
            content_.append("issueDate", issueDate.toISOString());
                    
        if (expireDate === null || expireDate === undefined)
            throw new Error("The parameter ‘expireDate’ cannot be null.");
        else
            content_.append("expireDate", expireDate.toISOString());
        
        if (file !== null && file !== undefined)
            content_.append("file", file, file.name ? file.name : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http2.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExpertCertificate(_response);
        });
    }
}